(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.setHeaderHeightOnMediaChange = this.setHeaderHeight.bind(this);
      this.desktopMediaQuery = window.matchMedia('(min-width: 990px)');
      this.onDesktopMediaChangeHandler = this.onDesktopMediaChange.bind(this);
      this.menuDetails = [];
      this.menuDetailCleanupCallbacks = [];
      this.menuCloseTimers = new WeakMap();

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeightOnMediaChange);
      this.desktopMediaQuery.addEventListener('change', this.onDesktopMediaChangeHandler);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      this.initDesktopMenuHover();
      this.onScroll();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeightOnMediaChange);
      this.desktopMediaQuery.removeEventListener('change', this.onDesktopMediaChangeHandler);
      this.cleanupDesktopMenuHover();
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const headerTop = this.headerBounds.top || 0;
      const headerBottom = this.headerBounds.bottom || this.header.offsetHeight;
      this.header.classList.toggle('is-scrolled', scrollTop > 0);

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (this.desktopMediaQuery.matches) {
        if (scrollTop > 0) {
          this.header.classList.add('scrolled-past-header', 'shopify-section-header-sticky');
          this.header.classList.remove('shopify-section-header-hidden');
        } else if (scrollTop <= headerTop) {
          this.header.classList.remove('scrolled-past-header');
          requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }

    onDesktopMediaChange() {
      this.cleanupDesktopMenuHover();
      this.initDesktopMenuHover();
      if (!this.desktopMediaQuery.matches) {
        this.header.classList.remove('has-open-menu');
      }
    }

    initDesktopMenuHover() {
      this.menuDetails = Array.from(this.header.querySelectorAll('header-menu > details'));
      if (!this.menuDetails.length) return;

      const handleHeaderMouseLeave = () => {
        if (!this.desktopMediaQuery.matches) return;
        this.menuDetails.forEach((detail) => this.closeMenuDetail(detail));
        this.updateDesktopMenuState();
      };
      this.header.addEventListener('mouseleave', handleHeaderMouseLeave);
      this.menuDetailCleanupCallbacks.push(() => this.header.removeEventListener('mouseleave', handleHeaderMouseLeave));

      this.menuDetails.forEach((detail) => {
        const summary = detail.querySelector('summary');
        if (!summary) return;

        const handleMouseEnter = () => {
          if (!this.desktopMediaQuery.matches) return;
          this.clearMenuCloseTimer(detail);
          this.openMenuDetail(detail);
        };
        const handleMouseLeave = () => {
          if (!this.desktopMediaQuery.matches) return;
          this.scheduleMenuClose(detail);
        };
        const handleFocusIn = () => {
          if (!this.desktopMediaQuery.matches) return;
          this.clearMenuCloseTimer(detail);
          this.openMenuDetail(detail);
        };
        const handleFocusOut = (event) => {
          if (!this.desktopMediaQuery.matches) return;
          if (detail.contains(event.relatedTarget)) return;
          this.closeMenuDetail(detail);
          this.updateDesktopMenuState();
        };
        const handleToggle = () => this.updateDesktopMenuState();

        detail.addEventListener('mouseenter', handleMouseEnter);
        detail.addEventListener('mouseleave', handleMouseLeave);
        detail.addEventListener('focusin', handleFocusIn);
        detail.addEventListener('focusout', handleFocusOut);
        detail.addEventListener('toggle', handleToggle);

        this.menuDetailCleanupCallbacks.push(() => {
          detail.removeEventListener('mouseenter', handleMouseEnter);
          detail.removeEventListener('mouseleave', handleMouseLeave);
          detail.removeEventListener('focusin', handleFocusIn);
          detail.removeEventListener('focusout', handleFocusOut);
          detail.removeEventListener('toggle', handleToggle);
        });
      });
    }

    cleanupDesktopMenuHover() {
      this.menuDetails.forEach((detail) => this.clearMenuCloseTimer(detail));
      this.menuDetailCleanupCallbacks.forEach((cleanup) => cleanup());
      this.menuDetailCleanupCallbacks = [];
    }

    scheduleMenuClose(detail) {
      this.clearMenuCloseTimer(detail);
      const timer = window.setTimeout(() => {
        this.closeMenuDetail(detail);
        this.updateDesktopMenuState();
      }, 120);
      this.menuCloseTimers.set(detail, timer);
    }

    clearMenuCloseTimer(detail) {
      const timer = this.menuCloseTimers.get(detail);
      if (!timer) return;
      window.clearTimeout(timer);
      this.menuCloseTimers.delete(detail);
    }

    openMenuDetail(targetDetail) {
      this.menuDetails.forEach((detail) => {
        if (detail !== targetDetail) {
          this.clearMenuCloseTimer(detail);
          this.closeMenuDetail(detail);
        }
      });

      this.clearMenuCloseTimer(targetDetail);
      if (!targetDetail.hasAttribute('open')) {
        targetDetail.setAttribute('open', '');
        targetDetail.querySelector('summary')?.setAttribute('aria-expanded', true);
      }

      this.updateDesktopMenuState();
    }

    closeMenuDetail(detail) {
      this.clearMenuCloseTimer(detail);
      if (!detail.hasAttribute('open')) return;
      detail.removeAttribute('open');
      detail.querySelector('summary')?.setAttribute('aria-expanded', false);
    }

    updateDesktopMenuState() {
      const hasOpenMenu = this.menuDetails.some((detail) => detail.hasAttribute('open'));
      this.header.classList.toggle('has-open-menu', hasOpenMenu);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
